import Tracking from 'august-ga4-base-tracking';
import { TRACKING_OPTIONS } from '../constants';

window.addEventListener('DOMContentLoaded', () => new Tracking(TRACKING_OPTIONS));
